import React from 'react';
import HeaderRow from './HeaderRow';
import MetaRow from './MetaRow';
import BodyContainer from './BodyContainer';
import BulletList from './BulletList';
import TagList from './TagList';

/**
 * BaseBlock is the foundational atomic container coordinating sub-block rows.
 * Governs layout hierarchy, text wrapping width, and metadata row offsets.
 */
export const BaseBlock = ({
  title,
  rightMeta,
  subtitle,
  leftMeta,
  subRightMeta,
  bullets = [],
  tags = [],
  style = {},
  children
}) => {
  return (
    <div 
      className="base-block-item" 
      data-split-child="true" 
      style={{ 
        width: '100%',
        ...style 
      }}
    >
      <HeaderRow title={title} rightMeta={rightMeta} />
      
      <MetaRow subtitle={subtitle} leftMeta={leftMeta} rightMeta={subRightMeta} />
      
      {(bullets.length > 0 || tags.length > 0 || children) && (
        <BodyContainer>
          <BulletList bullets={bullets} />
          <TagList tags={tags} />
          {children}
        </BodyContainer>
      )}
    </div>
  );
};
export default BaseBlock;
